import { render, staticRenderFns } from "./DetailsInfo.vue?vue&type=template&id=5dd5ed7e&scoped=true&"
import script from "./DetailsInfo.vue?vue&type=script&lang=js&"
export * from "./DetailsInfo.vue?vue&type=script&lang=js&"
import style0 from "./DetailsInfo.vue?vue&type=style&index=0&id=5dd5ed7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd5ed7e",
  null
  
)

export default component.exports